import { createRouter, createWebHashHistory} from 'vue-router'
import FeatureRequestApp from '../components/FeatureRequestApp'
import UserApp from '../components/UserApp'
import UserLogin from '../components/UserLogin'

const ifAuthenticated = (to, from, next) => {
    if (localStorage.getItem('token')) {
      next();
      return;
    }
    router.push({ 
      name: 'login',
      params: {
        returnTo: to.path,
        query: to.query,
      },
    });
};

const routes = [
    {path: '/login' , name: 'login', component: UserLogin},
    {path: '/features' , name: 'feature', component: FeatureRequestApp, beforeEnter: ifAuthenticated},
    {path: '/users' , name: 'user', component: UserApp, beforeEnter: ifAuthenticated},
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})



export default router